import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { GoldButton } from "@/components/GoldButton";
import { useWaitlist } from "@/context/WaitlistContext";
import { Apple, Play, ArrowRight } from "lucide-react";

const StoreBadge = ({ icon: Icon, top, bottom }) => (
  <button className="flex items-center gap-3 rounded-2xl border border-white/20 bg-white/10 px-5 py-3 text-left backdrop-blur-md transition-colors hover:bg-white/20">
    <Icon className="h-7 w-7 text-ivory" />
    <span>
      <span className="block text-[10px] uppercase tracking-wider text-ivory/60">{top}</span>
      <span className="block font-display text-base font-semibold text-ivory">{bottom}</span>
    </span>
  </button>
);

export const FinalCTA = () => {
  const { openWaitlist } = useWaitlist();
  return (
    <section id="final-cta" data-testid="final-cta" className="relative overflow-hidden bg-charcoal-deep py-28 sm:py-36">
      {/* dark to gold gradient wash */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_50%_120%,rgba(212,175,55,0.35),transparent_60%)]" />
        <div className="absolute -left-32 top-0 h-96 w-96 rounded-full bg-gold-rose/10 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-gold">
            श्रीधन · Begin today
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-serif text-5xl font-light leading-[1.05] tracking-tight text-ivory sm:text-6xl lg:text-7xl">
            Your golden habit <br /> starts with <span className="gold-shimmer">₹10</span>
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-ivory/70">
            Join 50,000+ savers building borderless wealth in gold. Set up your first Gold SIP
            in under a minute — no account, no jargon, no limits.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          <div className="mt-10 flex flex-col items-center gap-6">
            <GoldButton data-testid="final-cta-btn" size="lg" icon={ArrowRight} onClick={() => openWaitlist("final")}>
              Start your Gold SIP
            </GoldButton>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="flex flex-wrap items-center justify-center gap-3"
            >
              <StoreBadge icon={Apple} top="Download on the" bottom="App Store" />
              <StoreBadge icon={Play} top="Get it on" bottom="Google Play" />
            </motion.div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
